import { useEffect, useRef, useState } from "react";
import { userTypes } from "../../data/types/userTypes";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { objectToArray } from "../../utils/objectToArray";
import { docCodes } from "../../data/docCodes";
import { sectionTypes } from "../../data/types/sectionTypes";
import { stdObject } from "../../data/types/stdObject";
import { callDocuments } from "../../services/callDocuments";
import { filterSubsections } from "../../utils/filterSubsections";
import { getInputType } from "../../utils/getInputType";
import { arrayToObject } from "../../utils/arrayToObject";
import { useTranslation } from "react-i18next";
import {
  docsType,
  emptys,
  extraListCodes,
  listType,
  localListUpdate,
  personsCodes,
  serviceExtraCodes,
} from "../../data/main";
import { getChildrenValues } from "../../utils/getChildrenValues";
import { isDateBetween } from "../../utils/isDateBetween";
import { isNumberBetween } from "../../utils/isNumberBetween";
import { colors } from "../../data/colors";
import { updateRowData } from "../../store/updateData";
import { useMainContext } from "../../context/MainContext";
import { screensSearch } from "../../data/screensSearch";
import { sendData } from "../../services/sendData";
import { useScrollDirection } from "../../utils/useScrollDirection";
import { dateFallsWithin } from "../../utils/dateFallsWithin";
import { useReactToPrint } from "react-to-print";
import { callPersons } from "../../services/callPersons";
import { initSearchValue } from "./SearchBar/data/initSearchValue";
import { openStationery } from "../MainFrame/functions/stationery/openStationery";
import { openCat } from "../MainFrame/functions/category/openCat";
import { openRolInfo } from "../MainFrame/functions/rol/openRolInfo";
import { openReturnModal } from "./returns/functions/openReturnModal";
import { printTable } from "../MainFrame/functions/printTable";
import { printHeaders } from "../MainFrame/data/printHeadersData";
import { removeAccents } from "../../utils/removeAccents";
import { writePayloadReportData } from "./admin/functions/writePayloadReportData";
import { writeResponseReport } from "./admin/functions/writeResponseReport";
import { openInventory } from "../MainFrame/functions/inventory/openInventory";
import { openGraphInfo } from "../MainFrame/functions/openGraphInfo";
import { stationeryOptions } from "./SearchBar/data/searchItemUtils";
import { writeCommButtons } from "./commissions/writeCommButtons";
import { createBackup } from "../MainFrame/functions/createBackup";
import { backupArray } from "../../utils/backupArray";
import { directReload } from "../MainFrame/functions/directReload";
import { getCurrentDate } from "../../utils/getCurrentDate";
import { createAutomaticBackup } from "../MainFrame/functions/createAutomaticBackup";
import { openPrinterDialog } from "../MainFrame/functions/stationery/openPrinterDialog";

let searchCounter: any = false;

export default function useMainStructure({
  type,
  subSections,
  peopleId,
  height,
}: {
  type: string;
  subSections: stdObject;
  peopleId?: string;
  height: string;
}) {
  const { t } = useTranslation();
  const scrollDiv = useRef<HTMLDivElement | null>(null);
  const printArea = useRef<HTMLDivElement | null>(null);
  const scrollDirection = useScrollDirection(scrollDiv);
  const listData = useRef({
    data: [],
    filtered: [],
    length: 0,
    range: [0, 75],
  });
  const {
    updateListCodeRef,
    openServiceModal,
    selectMode,
    setSelectMode,
    updateDocData,
    customUpdate,
    openWindow,
    setDocValues,
    setStationeryModal,
    setMsg,
    openMsg,
    closeMsg,
    logoutAction,
    openUserInfo,
    selectStep,
    openMainInfo,
    handleMainData,
    calDocsList,
    setCalDocsList,
    setWindowValues,
    setModalData,
    setModalData2,
    setMsg2,
  } = useMainContext();
  const dispatch = useDispatch();
  const user: any = useSelector((state: RootState) => state.data.user);
  const userAccess: stdObject = useSelector(
    (state: RootState) => state.data.userAccess,
  );
  const listRow: any = useSelector((state: RootState) => state.data.listRow);
  const schedulesList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.hor,
  );
  const categories = useSelector((state: RootState) => state.data.cat);
  const headers: any = useSelector(
    (state: RootState) => state.data.headers ?? {},
  );
  const syncData: stdObject = useSelector(
    (state: RootState) => state.data.sync,
  );
  const itemsList: userTypes = useSelector(
    (state: RootState) => state.data.art,
  );
  const pricesRates: any = useSelector((state: RootState) => state.data.tar);
  const warehouses: any = useSelector((state: RootState) => state.data.alm);
  const vPayments: any = useSelector((state: RootState) => state.data.vtpa);

  const [section, setSection] = useState<sectionTypes>({
    id: false,
    code: "",
    search: {},
  });
  const [searchValues, setSearchValues] = useState<stdObject>({});
  const [headerInfo, setHeaderInfo] = useState<Array<stdObject>>([]);
  const [boxList, setBoxList] = useState<Array<object>>([]);
  const [catList, setCatList] = useState<Array<object>>([
    { label: t("p.all"), value: "", father: "" },
    { label: t("p.none"), value: 0, father: "" },
    ...categories
      .filter((e: stdObject) => e.PADCAT === "")
      .map((e: stdObject) => {
        return {
          value: e.CODCAT,
          label: e.NOMCAT,
          father: e.PADCAT,
        };
      }),
  ]);

  const handlePrint = useReactToPrint({ contentRef: printArea });

  useEffect(() => {
    if (headerInfo.length > 0) {
      handlePrint();
      setHeaderInfo([]);
    }
  }, [headerInfo]);

  const prepareToPrint = () => {
    setHeaderInfo([
      {
        name: user.NOMSUC,
        style: {
          fontSize: 16,
          fontWeight: "bolder",
          textAlign: "center",
        },
      },
      {
        name: user.RUCSUC,
        style: { fontSize: 16, textAlign: "center" },
      },
      {
        name: t("p.salesReport"),
        style: { fontSize: 16, textAlign: "center" },
      },
      {
        label: t("p.printDate"),
        name: "printDate",
      },
      {
        name: "shift",
        style: { marginBottom: 10 },
      },
    ]);
  };

  const extraSection =
    type !== "items" && typeof peopleId === "string"
      ? [
          {
            id: peopleId.toUpperCase(),
            code: peopleId.toUpperCase() + "2",
            value: user[peopleId.toUpperCase() as keyof typeof user] ?? 0,
          },
          { id: "ART", code: "ART", value: user.ART ?? 0 },
        ]
      : type === "admin" && user.LOGUSU
        ? [{ id: "LOG", code: "LOG", value: 1 }]
        : [];

  const selectOptions: stdObject = {
    PREART: pricesRates.map((e: stdObject) => {
      return {
        value: e.CODTAR,
        label: e.NOMTAR,
      };
    }),
    ALMART: warehouses.map((e: stdObject) => {
      return {
        value: e.CODALM,
        label: e.NOMALM,
      };
    }),
  };

  useEffect(() => {
    updateListCodeRef(height === "100%" ? section.code : false);
  }, [height]);

  useEffect(() => {
    if (
      "area" in customUpdate.current &&
      typeof section.id === "string" &&
      "results" in searchValues[section.id]
    ) {
      console.log(
        " searchValues[section.id].results;",
        searchValues[section.id].results[customUpdate.current.area][
          customUpdate.current.id
        ],
      );
      const { area, id, code, codes, key, value, commission } =
        customUpdate.current;
      const tempSearchData = searchValues;
      const mainArea =
        tempSearchData[section.id as keyof typeof tempSearchData];

      if ("code" in customUpdate.current) {
        let index = mainArea.results[area][id].list.findIndex(
          (e: stdObject) => e.CODCOYP === code,
        );
        if (index > -1) {
          mainArea.results[area][id].list[index][key] = value;
        }
      }

      if ("codes" in customUpdate.current) {
        if (
          dateFallsWithin(
            commission.FECCOYP,
            mainArea.FECICO.value,
            mainArea.FECICO.value2,
          )
        ) {
          mainArea.results[area][id].list.push({
            ...commission,
            ...writeCommButtons({
              t,
              name: "",
              serie: 0,
              commission,
              openWindow,
              setMsg,
              setModalData,
              closeMsg,
              reverseComm,
            }),
          });

          mainArea.results.items[id].list = mainArea.results.items[id].list.map(
            (e: stdObject) =>
              codes.some((v: stdObject) => {
                const itemData = [
                  e.DOCCOY,
                  e.SERCOY,
                  e.CODCOY,
                  e.LINCOY,
                  e.AGECOY,
                  e.GRUCOY,
                ];
                return (
                  v.length === itemData.length &&
                  v.every((val: Array<any>, i: number) => val === itemData[i])
                );
              })
                ? { ...e, PAGCOY: value }
                : e,
          );
        } else {
          mainArea.results.items[id].list = mainArea.results.items[
            id
          ].list.filter(
            (e: stdObject) =>
              !codes.some((v: stdObject) => {
                const itemData = [
                  e.DOCCOY,
                  e.SERCOY,
                  e.CODCOY,
                  e.LINCOY,
                  e.AGECOY,
                  e.GRUCOY,
                ];
                return (
                  v.length === itemData.length &&
                  v.every((val: Array<any>, i: number) => val === itemData[i])
                );
              }),
          );
          if (mainArea.results.items[id].list.length === 0) {
            delete mainArea.results.items[id];
          }
        }
      }
      customUpdate.current = {};
      setSearchValues({ ...tempSearchData });
    }
  }, [customUpdate.current]);

  useEffect(() => {
    if (height === "100%") {
      if (selectMode.active) {
        setSelectMode({ ...selectMode, backMenu: section.id });
        updateSection({ key: selectMode.goMenu });
        if (Object.keys(selectMode.searchParams).length) {
          cleanAllSearch("ART", selectMode.searchParams);
        }
      } else {
        setSelectMode({ ...selectMode, goMenu: "", target: "" });
        updateSection({ key: selectMode.backMenu });
      }
    }
  }, [selectMode.active]);

  useEffect(() => {
    if (selectMode.serviceStep === 3) {
      cleanAllSearch("CLI");
    }
  }, [selectMode.serviceStep]);

  useEffect(() => {
    if (
      typeof section.code === "string" &&
      extraListCodes.includes(section.code)
    ) {
      updateListInfo({ update: true });
    }
  }, [itemsList]);

  useEffect(() => {
    // console.log("header", subSections, headers);
    let tempSections: stdObject = {};
    [...filterSubsections(subSections), ...extraSection].forEach((e) => {
      const tKey = typeof e === "string" ? e : e.id;
      tempSections[tKey] =
        tKey in screensSearch
          ? screensSearch[tKey].list
          : docCodes[tKey] in headers
            ? "user" in headers[docCodes[tKey]] &&
              headers[docCodes[tKey]].user.length > 0
              ? headers[docCodes[tKey]].user
              : headers[docCodes[tKey]].default
            : [];

      const dataFiltered = tempSections[tKey]
        .filter((v: stdObject) => v.BUSCAB === 1)
        .map((v: stdObject) => {
          return {
            key: v.CODCAB,
            value: v.initValue
              ? initSearchValue(v.CODCAB, { user, userAccess })
              : "",
            value2: "",
            mode: v.MODCAB,
            ...getInputType(
              v.CODCAB,
              docCodes[tKey] ?? screensSearch[tKey]?.code,
              type,
              ["PREART", "ALMART"].includes(v.CODCAB)
                ? selectOptions[v.CODCAB][0].value
                : "",
            ),
          };
        });

      if (
        tempSections[tKey].filter((v: stdObject) => v.BORCAB > 0).length > 0
      ) {
        let sortValue = tempSections[tKey].reduce(
          (max: stdObject, obj: stdObject) =>
            obj.BORCAB > max.BORCAB ? obj : max,
        );
        dataFiltered.push({
          key: "SORT",
          value: sortValue.CODCAB,
          mode: sortValue.BDECAB,
        });
      }

      tempSections[tKey] = arrayToObject({
        key: "key",
        erase: ["key"],
        data: dataFiltered,
      });
    });
    setSearchValues({ ...tempSections });
    // console.log("tempsections", tempSections);
  }, []);

  const handleScroll = () => {
    const dScroll = scrollDiv.current;
    if (!dScroll) return;

    const scrollTop = dScroll.scrollTop;
    const isBottom =
      dScroll.scrollTop + dScroll.clientHeight >= dScroll.scrollHeight - 1;
    // const atStart = dScroll.scrollTop <= 1;
    // const distanceToBottom =
    //   dScroll.scrollHeight - (dScroll.scrollTop + dScroll.clientHeight);

    if (scrollDirection === "up") {
      if (scrollTop <= 50) {
        console.log("Has pasado 50px desde el inicio del scroll");
        listData.current = { ...listData.current, range: [0, 75] };
        setBoxList([...listData.current.filtered.slice(0, 75)]);
      }
      // if (atStart && scrollDirection === "up") {
      //   console.log("Llegaste al inicio del scroll");
      // }
    }
    if (scrollDirection === "down") {
      /*if (distanceToBottom <= 50) {
        console.log("Estás a 50px del final del scroll");
      }*/
      if (isBottom) {
        console.log("Llegaste al final del scroll");
        showNextListObjects(dScroll.scrollTop);
      }
    }
  };

  const showNextListObjects = (scrollBack: number = 0) => {
    if (listData.current.range[1] < listData.current.length) {
      // if (scrollDiv.current) {
      //   scrollDiv.current.scrollTo({
      //     top: (56 * scrollBack) / 100,
      //     // behavior: "smooth"
      //   });
      // }
      let range = [listData.current.range[0], listData.current.range[1] + 25];
      if (range[1] > listData.current.length) {
        range[1] = listData.current.length;
      }
      listData.current = { ...listData.current, range };

      setBoxList([...listData.current.filtered.slice(range[0], range[1])]);
    }
  };

  const getCatFatherInfo = (code: string) => {
    let value: stdObject = categories.filter(
      (e: stdObject) => e.CODCAT === Number(code),
    )[0];
    return typeof value === "object" ? value.PADCAT.toString() : "";
  };

  const reverseComm = async (code: number) => {
    setMsg("loading");
    const responseReverseComm = await sendData({
      endPoint: "deleteCommission",
      payload: { code },
      logoutAction,
    });
    console.log("responseReverseComm", responseReverseComm);
    if (responseReverseComm.success && responseReverseComm.status) {
      findServiceData();
    }
  };

  const updateSearchValues = ({
    key,
    type,
    value,
    valueKey,
    mode,
    searchList = searchValues,
  }: stdObject) => {
    const id = section.id as keyof typeof searchList;
    const { code } = section;

    if (searchCounter) {
      clearTimeout(searchCounter);
    }

    if (key === "FAMART") {
      let tempCat = categories.filter((e: stdObject) => e.PADCAT === value);
      if (tempCat.length > 0) {
        if (value === "") {
          setCatList([
            { label: t("p.all"), value: "", father: "" },
            { label: t("p.none"), value: 0, father: "" },
            ...tempCat.map((e: stdObject) => {
              return {
                value: e.CODCAT,
                label: e.NOMCAT,
                father: e.PADCAT,
              };
            }),
          ]);
        } else {
          const targetCat: stdObject = categories.filter(
            (e: stdObject) => Number(e.CODCAT) === Number(value),
          )[0];
          value = getChildrenValues(value, categories).join(",");

          setCatList([
            { label: t("p.all"), value: "", father: "" },
            {
              label: `◄ ${t("p.back")}`,
              value: targetCat.PADCAT,
              father: getCatFatherInfo(targetCat.PADCAT),
            },
            {
              label: targetCat.NOMCAT,
              value,
              father: targetCat.PADCAT,
            },
            ...tempCat.map((e: stdObject) => {
              return {
                label: `\u00A0\u00A0\u00A0• ${e.NOMCAT}`,
                value: e.CODCAT,
                father: e.PADCAT,
              };
            }),
          ]);
        }
      }
    }
    const newValue =
      key === "SORT" && valueKey === "mode"
        ? value === "1"
          ? "0"
          : "1"
        : valueKey === "mode" && value > 3
          ? 0
          : value;

    searchList[id][key][valueKey] = newValue;

    // console.log("searchList", searchList);
    switch (key) {
      case "SCHIRE":
        if (newValue !== "") {
          const newSchedule: stdObject | undefined = schedulesList.find(
            (e: stdObject) => e.CODHOR === Number(newValue),
          );
          if (typeof newSchedule === "object") {
            searchList[id].HORIRE.value = newSchedule.HOR1HOR;
            searchList[id].HORIRE.value2 = newSchedule.HOR2HOR;
          }
        }
        break;
      case "FECHIS":
        delete searchList[id].results;
        break;
      case "CUEICA":
        if (searchList[id].FECICA.value !== "") {
          findServiceData({ CUEICA: newValue });
        }
        break;
    }

    if (id === "D1" && "results" in searchList[id]) {
      delete searchList[id].header;
      delete searchList[id].results;
    }
    setSearchValues({ ...searchList });

    if (
      !["C2", "C3"].includes(code as string) &&
      typeof id === "string" &&
      id in docCodes
    ) {
      searchCounter = setTimeout(
        () =>
          updateListInfo({
            searchList,
            update: !localListUpdate.includes(typeof id === "string" ? id : ""),
          }),
        1000,
      );
    }
  };

  const saveInfoData = async (isOk: boolean = false) => {
    const mainInnerData =
      searchValues[section.id as keyof typeof searchValues].results;
    const mainHeader =
      searchValues[section.id as keyof typeof searchValues].header;
    if (isOk) {
      if ("shift" in mainInnerData) {
        setMsg("loading");
        const payloadSaveInfoData = {
          branch: user.CODSUC,
          shift: mainInnerData.shift,
          date: mainInnerData.date.split("-"),
          data: { results: mainInnerData, header: mainHeader },
        };
        console.log("payloadSaveInfoData", payloadSaveInfoData);
        const responseSaveInfoData = await sendData({
          endPoint: "saveSalesReport",
          payload: payloadSaveInfoData,
          logoutAction,
        });
        console.log("responseSaveInfoData", responseSaveInfoData);
        if (responseSaveInfoData.success && responseSaveInfoData.status) {
          setMsg("custom1");
          setModalData({ title: t("p.reportSaved") });
          if (responseSaveInfoData.backup) {
            // setModalData({
            //   code: "loading",
            //   title: t("p.reportSavedAndBackup"),
            // });
            createAutomaticBackup(getCurrentDate(true).split(" "), {
              logoutAction,
              closeMsg,
            });
          }
          let tempSearch = searchValues;
          tempSearch[section.id as keyof typeof searchValues].results.recorded =
            true;
          setSearchValues({ ...tempSearch });
        }
      }
    } else {
      setMsg("loading");

      const payloadCheckSalesReport = {
        branch: user.CODSUC,
        shift: mainInnerData.shift,
        date: mainInnerData.date.split("-"),
      };
      console.log("payloadCheckSalesReport", payloadCheckSalesReport);
      const responseCheckSalesReport = await sendData({
        endPoint: "checkSalesReport",
        payload: payloadCheckSalesReport,
        logoutAction,
      });
      console.log("responseCheckSalesReport", responseCheckSalesReport);
      const { success, status, exists, isEmpty } = responseCheckSalesReport;
      if (success && status) {
        if (exists) {
          setMsg("custom1");
          setModalData({ title: t("p.reportAlreadyExists") });
        } else if (isEmpty) {
          setMsg("custom1");
          setModalData({
            code: "warning",
            label: t("p.afterSaveSalesReport"),
            buttons: [
              {
                label: t("p.save"),
                onClick: () => saveInfoData(true),
                color: colors.green,
              },
              {
                label: t("p.cancel"),
                onClick: () => {
                  closeMsg();
                  setModalData({});
                },
                color: colors.darkGrey,
              },
            ],
          });
        }
        return true;
      }
      closeMsg();
    }
  };

  const cleanAllSearch = (searchCode = section.id, params: stdObject = {}) => {
    if (typeof searchCode === "string" && searchCode in searchValues) {
      let searchList = searchValues;
      const innerCode = searchCode as keyof typeof searchValues;
      Object.keys(searchValues[searchCode]).forEach((e: string) => {
        if (e !== "SORT") {
          if (e in params) {
            searchList[innerCode][e] = params[e];
          } else {
            searchList[innerCode][e].value = "";
            searchList[innerCode][e].value2 = "";
            if ("option" in searchList[innerCode][e])
              searchList[innerCode][e].option = "";
          }
        }
      });
      setSearchValues({ ...searchList });

      updateListInfo({
        key: searchCode,
        searchList,
        update: !localListUpdate.includes(
          typeof searchCode === "string" ? searchCode : "",
        ),
      });
    }
  };

  const getRowValue = ({ v, e, searchFiltered }: any) => {
    switch (v) {
      case "PREPCO":
        return typeof user.CODPAI === "string" && user.CODPAI in e[v]
          ? e[v][user.CODPAI as any]
          : "";
      case "PREART":
        return typeof user.CODPAI === "string" &&
          user.CODPAI in e[v] &&
          searchFiltered[v].option in e[v][user.CODPAI as any]
          ? e[v][user.CODPAI as any][searchFiltered[v].option].PRELTA
          : "";
      case "ALMART":
        return searchFiltered[v].option in e[v]
          ? e[v][searchFiltered[v].option].ACTSTO
          : "";
      default:
        return e[v] ? e[v].toString().toLowerCase() : "";
    }
  };

  const updateListInfo = async ({
    key = section.id,
    update = false,
    restart = true,
    searchList = searchValues,
    loading = false,
    print = false,
  }: stdObject) => {
    if (loading) setMsg2("loading");
    let tempList: stdObject = {};
    let tempSection =
      typeof key === "string" && key in docCodes ? docCodes[key] : key;
    const peopleCode =
      typeof peopleId === "string" ? peopleId.toUpperCase() : "";
    if (typeof tempSection === "string" && (update || print)) {
      switch (tempSection) {
        case peopleCode:
          if (typeof peopleId === "string" && peopleCode !== "") {
            // console.log("searchList", searchList[peopleId.toUpperCase()]);
            if (restart) setBoxList([]);
            tempList.data = await callPersons({
              type: peopleId,
              searchList: searchList[peopleId.toUpperCase()],
              print,
              sort:
                "SORT" in searchList[peopleId.toUpperCase()]
                  ? searchList[peopleId.toUpperCase()].SORT
                  : false,
              logoutAction,
            });
          }
          break;
        case "ART":
          tempList.data = ["sales", "services"].includes(type)
            ? objectToArray("CODART", itemsList).filter(
                (e: stdObject) => e.TIPART !== 6,
              )
            : objectToArray("CODART", itemsList);
          break;
        default:
          // if (typeof section.code === "string" && (!(section.code in syncData) || syncData[section.code])) {
          if (restart) setBoxList([]);
          tempList.data = await callDocuments({
            user: [1, 5].includes(user.TEC) ? user.CODUSU : "",
            code: tempSection.toLowerCase(),
            dates:
              `FEC${tempSection}` in searchValues[key]
                ? [
                    searchValues[key][`FEC${tempSection}`].value,
                    searchValues[key][`FEC${tempSection}`].value2,
                  ]
                : ["", ""],
            sort: "SORT" in searchValues[key] ? searchValues[key].SORT : false,
            search: searchValues[key],
            print,
            ser: user.CODSUC ?? 0,
            warehouse: user.ALMSUC,
            logoutAction,
          });
        // }
      }
      // console.log("tempList", tempList);
    } else {
      tempList.data = listData.current.data;
    }
    tempList.filtered = tempList.data;
    const searchFiltered: stdObject = key
      ? Object.fromEntries(
          Object.entries(searchList[key as keyof typeof searchList]).filter(
            ([key, value]: Array<any>) => key !== "SORT" && value.value !== "",
          ),
        )
      : {};

    var sortValues: stdObject;
    if (Object.keys(searchFiltered).length > 0 && tempList.data) {
      tempList.filtered = tempList.data.filter((e: stdObject) =>
        Object.keys(searchFiltered)
          .map((v) => {
            if (
              typeof searchFiltered[v].value === "string" &&
              ["string", "number", "object"].includes(typeof e[v])
            ) {
              let rowValue = getRowValue({ v, e, searchFiltered });
              let searchValue = searchFiltered[v].value.toLowerCase();
              if ([1, 2, 3].includes(searchFiltered[v].mode)) {
                rowValue = removeAccents(rowValue);
                searchValue = removeAccents(searchValue);
              }

              switch (searchFiltered[v].mode) {
                case 3:
                  return rowValue.includes(searchValue);
                case 2:
                  return rowValue.endsWith(searchValue);
                case 1:
                  return rowValue.startsWith(searchValue);
                default:
                  return "isMultiDate" in searchFiltered[v]
                    ? v === `FEC${tempSection}` &&
                      !["ART", peopleCode].includes(tempSection)
                      ? true
                      : isDateBetween(
                          rowValue,
                          searchFiltered[v].value,
                          searchFiltered[v].value2,
                        )
                    : "isMultiNumber" in searchFiltered[v]
                      ? isNumberBetween(
                          rowValue,
                          searchFiltered[v].value,
                          searchFiltered[v].value2,
                        )
                      : "isMultiSelect" in searchFiltered[v]
                        ? searchFiltered[v].value.split(",").includes(rowValue)
                        : rowValue === searchFiltered[v].value.toLowerCase();
              }
            } else {
              return false;
            }
          })
          .every((value) => value === true),
      );
    }
    if (
      "SORT" in searchList[key as keyof typeof searchList] &&
      tempList.filtered
    ) {
      sortValues = searchList[key as keyof typeof searchList].SORT;
      tempList.filtered.sort((a: any, b: any) =>
        typeof a[sortValues.value] === "number"
          ? sortValues.mode === "1"
            ? a[sortValues.value] - b[sortValues.value]
            : b[sortValues.value] - a[sortValues.value]
          : sortValues.mode === "1"
            ? a[sortValues.value].localeCompare(b[sortValues.value], "es", {
                sensitivity: "base",
              })
            : b[sortValues.value].localeCompare(a[sortValues.value], "es", {
                sensitivity: "base",
              }),
      );
    }
    if (print) {
      if (loading) closeMsg(2);
      return tempList.filtered;
    } else if (tempList.data && tempList.filtered) {
      listData.current = {
        data: tempList.data,
        filtered: tempList.filtered,
        length: tempList.filtered.length,
        range: [0, 75],
      };

      if (tempList.filtered.length > 75) {
        tempList.filtered = tempList.filtered.slice(0, 75);
      }

      if (scrollDiv.current && !update) {
        scrollDiv.current.scrollTo({
          top: 0,
          // behavior: "smooth"
        });
      }
      setBoxList([...tempList.filtered]);
    }
    if (loading) closeMsg(2);
  };

  useEffect(() => {
    if (
      listRow.type === section.code ||
      (listRow.type === "SEV" && section.code === "C2")
    ) {
      if (listRow.type === "SEV" && section.code === "C2") {
        let tempDocsList = calDocsList;
        listRow.data.forEach((e: stdObject) => {
          let index = tempDocsList.findIndex(
            (v: stdObject) =>
              v[`SER${listRow.type}`] === e[`SER${listRow.type}`] &&
              v[`COD${listRow.type}`] === e[`COD${listRow.type}`],
          );
          if (index > -1) {
            tempDocsList[index].data = e;
          } else {
            tempDocsList.unshift({ type: listRow.type, data: e });
          }
        });
        setCalDocsList([...tempDocsList]);
      } else {
        /*setBoxList((prev) => {
          const tempList = prev;
          if (Array.isArray(listRow.data)) {
            listRow.data.forEach((e: stdObject) => {
              let index;
              if (e.deleteCode) {
                index = tempList.findIndex(
                  (v: stdObject) => v[`COD${listRow.type}`] === e.deleteCode,
                );
                if (index > -1) {
                  tempList.splice(index, 1);
                }
              } else {
                index = tempList.findIndex(
                  (v: stdObject) =>
                    (extraListCodes.includes(listRow.type) &&
                      v[`COD${listRow.type}`] === e[`COD${listRow.type}`]) ||
                    (!extraListCodes.includes(listRow.type) &&
                      v[`SER${listRow.type}`] === e[`SER${listRow.type}`] &&
                      v[`COD${listRow.type}`] === e[`COD${listRow.type}`]),
                );
                if (index > -1) {
                  tempList[index] = e;
                } else {
                  tempList.unshift(e);
                }
              }
            });
          }
          return tempList;
        });*/
        if (section.code === listRow.type)
          updateListInfo({ update: true, restart: false });
      }
      dispatch(
        updateRowData({
          type: false,
          data: [],
        }),
      );
    }
  }, [listRow]);

  const updateSection = async ({ key = "" }: stdObject) => {
    setSection({
      id: key,
      code:
        typeof key === "string"
          ? key in screensSearch
            ? screensSearch[key].code
            : key in docCodes
              ? docCodes[key]
              : key
          : key,
      search: { ...section.search },
    });
    updateListCodeRef(
      typeof key === "string" && key in docCodes ? docCodes[key] : false,
    );
    let searchList = searchValues;
    if (!(key in searchValues)) {
      searchList[key] = {};
      setSearchValues({ ...searchList });
    }

    if (Object.keys(screensSearch).includes(key)) {
      // console.log("erer");
    } else if (listType.std.includes(key)) {
      // console.log("erer");
    } else if (typeof key === "string") {
      updateListInfo({ key, update: true, searchList, loading: true });
    }
  };

  const openSettings = async () => {
    setMsg("loading");
    const resultWebSettings: stdObject = await sendData({
      endPoint: "callWebSettings",
      payload: {},
      logoutAction,
    });
    console.log("resultWebSettings: ", resultWebSettings);
    const { success, status, main, ftp, mail } = resultWebSettings;
    if (success && status) {
      setMsg("webSettingsModal");
      setWindowValues({ webSettings: { ...main, ...ftp, ...mail } });
    } else {
      closeMsg();
    }
  };

  const openExport = async () => {
    setMsg("loading");
    const payloadStaList = { code: "all" };
    console.log("payloadStaList: ", payloadStaList);
    const resultStaList: stdObject = await sendData({
      endPoint: "callStaList",
      payload: payloadStaList,
      logoutAction,
    });
    console.log("resultStaList: ", resultStaList);

    let container: stdObject = [];
    if (resultStaList.success) {
      stationeryOptions.map((e: stdObject) => {
        const temp = resultStaList.list
          .filter((v: stdObject) => v.TIPDOC === e.value)
          .map((v: stdObject) => {
            return { ...v, value: 1 };
          });
        if (temp.length > 0) {
          container.push(...temp);
        }
      });
    }
    setMsg("exportStaModal");
    setWindowValues({ type: "export", exportStaList: container });
  };

  const openImport = () => {
    const input = document.createElement("input");

    input.type = "file";
    input.accept = ".sta";

    input.onchange = async () => {
      const fileToExport = input.files?.[0];
      if (!fileToExport) return;

      const reader = new FileReader();

      reader.onload = async () => {
        const data = reader.result as string;
        try {
          const resultStaList = await sendData({
            endPoint: "getImportStationery",
            payload: { data },
            logoutAction,
          });
          console.log("resultStaList", resultStaList);

          let container: stdObject = [];
          stationeryOptions.map((e: stdObject) => {
            const temp = resultStaList.data.data
              .filter((v: stdObject) => v.TIPDOC === e.value)
              .map((v: stdObject) => {
                return { ...v, value: 1 };
              });
            if (temp.length > 0) {
              container.push(...temp);
            }
          });
          setMsg("exportStaModal");
          setWindowValues({
            type: "import",
            exportStaList: container,
            parts: resultStaList.data.parts,
          });
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      };

      reader.onerror = () => {
        console.error("Error uploading file.");
      };

      reader.readAsText(fileToExport);
    };

    input.click();
  };

  const sendNewInfo = ({
    code = "",
    nextDate = null,
  }: {
    code: number | string;
    nextDate: null | string;
  }) => {
    // console.log("mmm", section.code);
    switch (section.code) {
      case "V1":
        openGraphInfo(
          { CODGRA: "" },
          {
            t,
            setMsg,
            setModalData,
            setModalData2,
            setWindowValues,
            logoutAction,
          },
        );
        break;
      case "USU":
        openUserInfo({ CODUSU: "" });
        break;
      case "BCK":
        setMsg("custom1");
        setModalData({
          title: t("p.askCreateBackup"),
          label: t("p.processWillTakeTime"),
          blocked: true,
          buttons: [
            {
              label: t("p.create"),
              onClick: () =>
                createBackup({
                  t,
                  setMsg,
                  setModalData,
                  setModalData2,
                  searchValues,
                  setSearchValues,
                  closeMsg,
                  logoutAction,
                }),
              color: colors.green,
            },
            {
              label: t("p.cancel"),
              onClick: closeMsg,
              color: colors.darkGrey,
            },
          ],
        });
        break;
      case "ROL":
        openRolInfo(
          { id: "" },
          {
            t,
            setMsg,
            setModalData,
            setModalData2,
            setWindowValues,
            logoutAction,
          },
        );
        break;
      case "MAR":
      case "ICA":
        const params =
          section.code === "ICA"
            ? {
                CODCAJ: "",
                SUCCAJ: user.CODSUC,
                TIPCAJ:
                  searchValues[section.id as keyof typeof searchValues].CUEICA
                    .value === ""
                    ? "0"
                    : searchValues[section.id as keyof typeof searchValues]
                        .CUEICA.value,
              }
            : { CODMAR: "" };
        handleMainData(params, -1, false);
        break;
      case "SUC":
      case "ADM":
      case "ACO":
      case "ISU":
      case "D8":
        let key =
          searchValues[section.id as keyof typeof searchValues][
            `COD${section.code}`
          ]?.value;
        key ||= listType[section.id as keyof typeof listType].type;
        openMainInfo(
          {
            [`COD${["CTPA", "VTPA"].includes(key) ? "TPA" : key}`]: -1,
          },
          -1,
          key,
        );
        break;
      case "INV":
        openInventory("", "", {
          t,
          user,
          setWindowValues,
          setModalData,
          setMsg,
          setMsg2,
          closeMsg,
          logoutAction,
        });
        break;
      case "CAT":
        openCat("", "", true, {
          t,
          categories,
          setWindowValues,
          setModalData,
          setMsg,
          setMsg2,
          closeMsg,
          logoutAction,
        });
        break;
      case "STA":
        setMsg("custom1");
        setModalData({
          title: t("p.newSTA"),
          label: t(`c.${searchValues.Z12.SECTSTA.value}`),
          inputs: [
            {
              label: t("p.new"),
              type: "button",
              style: { width: "100%" },
              onClick: () =>
                openStationery(
                  {
                    type: searchValues.Z12.SECTSTA.value,
                    code: "new",
                  },
                  {
                    setDocValues,
                    setStationeryModal,
                    setMsg,
                    closeMsg,
                    logoutAction,
                  },
                ),
            },
            {
              label: t("p.copy"),
              type: "button",
              style: { width: "100%" },
              onClick: () => {
                setWindowValues({
                  staData: {
                    type: searchValues.Z12.SECTSTA.value,
                    document: "",
                    code: "",
                    list: [],
                  },
                });
                setMsg("cloneStationeryModal");
              },
            },
          ],
          buttons: [
            {
              label: t("p.cancel"),
              onClick: closeMsg,
              color: colors.darkGrey,
            },
          ],
        });
        break;
      case "SEV":
        openServiceModal({});
        break;
      case "REG":
        openReturnModal({ branch: user.CODSUC, setMsg, setWindowValues });
        break;
      default:
        const isService =
          typeof section.id === "string" &&
          serviceExtraCodes.includes(section.id);
        let isEdit = user[`${section.code}`];
        let msgName =
          typeof section.code === "string" &&
          extraListCodes.includes(section.code)
            ? "personItem"
            : isService
              ? "selectiveWindow"
              : "doc";
        let modalInfo = {
          label: t(`p.new${section.code}`, { code: t(`c.${section.code}`) }),
          mainColor: colors[type],
          typeText: type,
          type: isService ? "C1" : section.id,
          doc: isService ? "SEV" : section.code,
          nextDate,
          isEdit,
          code,
        };
        openWindow({
          msgName,
          modalInfo,
          level: msgName === "personItem" ? 1 : 0,
        });
        break;
    }
  };

  const openRowInfo = (data: stdObject, code: string) => {
    if (selectMode.active) {
      if (selectMode.serviceStep > 0) {
        selectStep(selectMode.serviceStep, data);
      } else {
        updateDocData(data);
      }
    } else {
      let isEdit =
        typeof section.code === "string" &&
        extraListCodes.includes(section.code)
          ? user[section.code]
          : 0;
      switch (section.code) {
        case "ART":
        case "CLI":
        case "PRO":
          openWindow({
            msgName: "personItem",
            modalInfo: {
              label: data[`NOM${section.code}`],
              mainColor: colors[type],
              type: section.id === "F2" ? "ART" : section.id,
              doc: section.code,
              isEdit,
              code: data[`COD${section.code}`],
            },
            level: 1,
          });
          break;
        default:
          switch (code) {
            case "DIN":
              subSections[`${section.id}C` as keyof typeof subSections]
                ? openWindow({
                    msgName: "payments",
                    modalInfo: {
                      title: data[`NOM${section.code}`],
                      label: `${section.code}.${data[`SER${section.code}`]}-${
                        data[`COD${section.code}`]
                      }`,
                      mainColor: colors[type],
                      type: section.id,
                      doc: section.code,
                      isEdit: true,
                      serie: data[`SER${section.code}`],
                      code: data[`COD${section.code}`],
                    },
                  })
                : openMsg("error", { label: t("p.accessBlocked") });
              break;
            default:
              const codeType =
                "DOCORD" in data
                  ? "ORD"
                  : (docsType[section.code as keyof typeof docsType] ??
                    String(section.code));
              openWindow({
                msgName: "document",
                modalInfo: {
                  title: data[`NOM${codeType}`],
                  label: `${codeType}.${data[`SER${codeType}`]}-${
                    data[`COD${codeType}`]
                  }`,
                  mainColor: colors[type],
                  typeText: type,
                  type:
                    typeof section.id === "string" &&
                    serviceExtraCodes.includes(section.id)
                      ? "C1"
                      : section.id,
                  isEdit: true,
                  doc:
                    "DOCORD" in data
                      ? data.DOCORD
                      : (docsType[section.code as keyof typeof docsType] ??
                        section.code),
                  serie: data[`SER${codeType}`],
                  code: data[`COD${codeType}`],
                },
              });
              break;
          }
          break;
      }
    }
  };

  const restoreBackup = async (file: string) => {
    setMsg("custom1");
    setModalData({
      code: "loading",
      title: t("p.dontCloseApp"),
      label: t("p.waitUntilFinishUpdateDB"),
    });
    const responseBackupInfo: stdObject = await sendData({
      endPoint: "restoreBackup",
      payload: { file },
      logoutAction,
    });
    const { success, status } = responseBackupInfo;
    if (success && status) {
      setModalData({
        code: "warning",
        title: t("p.applicationNeedsRestarted"),
        blocked: true,
        buttons: [
          {
            label: t("p.restart"),
            onClick: () => {
              directReload();
              setMsg("loading");
            },
          },
        ],
      });
    } else {
      setModalData({
        code: "error",
        title: t("p.errorUpdatingDB"),
      });
    }
  };

  const deleteBackup = async (file: string) => {
    setMsg("loading");
    const responseBackupInfo: stdObject = await sendData({
      endPoint: "deleteBackup",
      payload: { file },
      logoutAction,
    });
    const { success, status, backup } = responseBackupInfo;
    let tempSearch = searchValues;
    if (success && status) {
      tempSearch.Z6.results = backupArray(backup);
      setSearchValues({ ...tempSearch });
    }
    closeMsg();
  };

  const openBackup = (name: string) => {
    setMsg("custom1");
    setModalData({
      title: name,
      buttons: [
        {
          label: t("p.restore"),
          onClick: () =>
            setModalData({
              code: "warning",
              title: name,
              label: t("p.areYouSureRestoreBackup"),
              buttons: [
                {
                  label: t("p.restore"),
                  onClick: () => restoreBackup(name),
                  color: colors.green,
                },
                {
                  label: t("p.cancel"),
                  onClick: closeMsg,
                  color: colors.darkGrey,
                },
              ],
            }),
          color: colors.green,
        },
        {
          label: t("p.delete"),
          onClick: () =>
            setModalData({
              code: "warning",
              title: name,
              label: t("p.areYouSureDeleteBackup"),
              buttons: [
                {
                  label: t("p.delete"),
                  onClick: () => deleteBackup(name),
                  color: colors.red,
                },
                {
                  label: t("p.cancel"),
                  onClick: closeMsg,
                  color: colors.darkGrey,
                },
              ],
            }),
          color: colors.red,
        },
        {
          label: t("p.cancel"),
          onClick: closeMsg,
          color: colors.darkGrey,
        },
      ],
    });
  };

  const callBackupInfo = async () => {
    setMsg("loading");
    const responseBackupInfo: stdObject = await sendData({
      endPoint: "getBackup",
      logoutAction,
    });
    const { success, status, backup } = responseBackupInfo;
    let tempSearch = searchValues;
    tempSearch.Z6.results = success && status ? backupArray(backup) : [];
    setSearchValues({ ...tempSearch });
    closeMsg();
  };

  const summatoryTotals = () =>
    Object.values(docCodes).filter(
      (e) =>
        typeof section.code === "string" &&
        ![...extraListCodes, "TRA"].includes(section.code) &&
        section.code === e,
    ).length > 0;

  const findServiceData = async (
    updates: boolean | stdObject = false,
    openMsg = true,
  ) => {
    console.log("findServiceData", section);
    const id = section.id as keyof typeof searchValues;
    const { code } = section;
    let tempValues = searchValues;
    if (typeof id === "string" && Array.isArray(updates)) {
      Object.entries(updates).forEach(([key, value]: [string, any]) => {
        tempValues[id][key].value = value;
      });
    }

    const checkIsOk = () => {
      if (
        !emptys.includes(tempValues[id][`FEC${code}`]?.value) ||
        (typeof id === "string" && ["D2", "LOG"].includes(id))
      ) {
        return true;
      } else if (id === "D1") {
        return (
          !emptys.includes(tempValues[id]?.SCHIRE?.value) &&
          !emptys.includes(tempValues[id][`FEC3${code}`]?.value)
        );
      } else if (id === "F5") {
        return (
          (typeof tempValues[id]?.CODBAT?.value === "string" &&
            tempValues[id]?.CODBAT?.value.trim().length > 0) ||
          (typeof tempValues[id]?.BATBAT?.value === "string" &&
            tempValues[id]?.BATBAT?.value.trim().length > 0)
        );
      }
      return false;
    };

    if (
      typeof id === "string" &&
      typeof screensSearch[id]?.service === "string" &&
      checkIsOk()
    ) {
      if (openMsg) {
        setMsg("loading");
      }
      const payloadReportData: stdObject = await writePayloadReportData({
        t,
        user,
        id,
        code,
        tempValues,
        schedulesList,
        setMsg,
        setModalData2,
        closeMsg,
        logoutAction,
      });

      console.log(
        "payloadReportData",
        screensSearch[id].service,
        payloadReportData,
      );
      if ("serie" in payloadReportData) {
        const responseReportData: stdObject = await sendData({
          endPoint: screensSearch[id].service,
          payload: payloadReportData,
          logoutAction,
        });
        console.log("responseReportData", responseReportData);

        if (responseReportData.success && responseReportData.status) {
          let newReportData: stdObject = await writeResponseReport({
            t,
            user,
            id,
            itemsList,
            tempValues,
            responseReportData,
            vPayments,
            openWindow,
            setMsg,
            setModalData,
            closeMsg,
            reverseComm,
          });
          console.log("newReportData", newReportData);
          setSearchValues(newReportData);
        }
        console.log("responseReportData", responseReportData);
      }

      if (!payloadReportData.isOk && openMsg) {
        closeMsg();
      }
    }
  };

  const printTickets = async () => {
    const data = await updateListInfo({
      update: true,
      loading: true,
      print: true,
    });
    openPrinterDialog(
      { sectionType: section, data, type, serie: user.CODSUC },
      {
        setDocValues,
        setStationeryModal,
        setMsg,
        closeMsg,
        logoutAction,
      },
    );
  };

  const printList = async (code: string, isOk = 0, values: stdObject) => {
    if (!isOk) {
      const printTotal = code === "ART" ? listData.current.filtered.length : 0;
      if (printTotal > 500) {
        setMsg("custom1");
        setModalData({
          label: t("p.askToPrintMaxLines", {
            lines: printTotal,
          }),
          buttons: [
            {
              label: t("p.print"),
              onClick: () => printList(code, 1, values),
              color: colors.green,
            },
            {
              label: t("p.cancel"),
              onClick: closeMsg,
              color: colors.darkGrey,
            },
          ],
        });
        return;
      } else {
        isOk = 1;
      }
    }

    if (isOk === 1) {
      setMsg("printFieldsModal");
      let totalFields =
        code === "ART"
          ? [
              ...printHeaders[code as keyof typeof printHeaders],
              ...pricesRates.map((e: stdObject) => {
                return { label: e.NOMTAR, code: e.CODTAR, type: "price" };
              }),
              ...warehouses.map((e: stdObject) => {
                return { label: e.NOMALM, code: e.CODALM, type: "stock" };
              }),
            ]
          : personsCodes.includes(code)
            ? printHeaders[code as keyof typeof printHeaders]
            : printHeaders[code as keyof typeof printHeaders];
      console.log("printList", code, totalFields);
      if (user.PCO === 0) {
        totalFields = totalFields.filter(
          (e: stdObject) => e.code !== "PREPCO" && !e.code.startsWith("PCO"),
        );
      }
      setWindowValues({
        printFields: [...totalFields],
      });
      setModalData({ printCode: code, printList, printTickets, totalFields });
    } else {
      let printRowData = {};
      switch (code) {
        case "ART":
          printRowData = { warehouses };
          break;
        default:
          // printRowData = {};
          break;
      }
      printTable({
        t,
        title: t(`c.${code}`),
        headers: values.printFields.filter((e: any) => e),
        country: user.CODPAI,
        xls: isOk === 3,
        data: await updateListInfo({
          update: true,
          loading: true,
          print: true,
        }),
        ...printRowData,
      });
    }
  };

  return {
    subSections,
    section,
    updateSection,
    updateSearchValues,
    extraSection,
    headers,
    boxList,
    searchValues,
    setSearchValues,
    selectOptions,
    catList,
    categories,
    cleanAllSearch,
    saveInfoData,
    sendNewInfo,
    openRowInfo,
    summatoryTotals,
    findServiceData,
    scrollDiv,
    handleScroll,
    listData,
    printArea,
    prepareToPrint,
    headerInfo,
    closeMsg,
    openSettings,
    openExport,
    openImport,
    printList,
    callBackupInfo,
    openBackup,
  };
}
